import { compact, uniq } from 'lodash';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { observer } from 'mobx-react';
import { RelatedDataStoreProvider } from '../../../related-data/related-data-provider';
import { RelatedDataPollExistingEvent } from '../../../related-data/related-data-poll';
import { RelatedDataTabContentExistingEvent } from './related-data-tab-content-existing-event';
import { useEventRelatedDataExistingEventQuery } from '../../event-state/use-event-related-data-existing-event-query';

export const RelatedDataTabExistingEvent = observer(function RelatedDataTabExistingEvent(props: {
    eventId: number;
}) {
    const eventMetadata = useEventMetadataStore().state.metadata;

    const eventRelatedDataExistingEventQuery = useEventRelatedDataExistingEventQuery({
        eventId: props.eventId,
        lastUpdatedDateUtc: eventMetadata?.lastUpdatedDateUtc,
    });

    const eventPanelForm = eventRelatedDataExistingEventQuery.data;

    const reportingParties = eventPanelForm?.reportingParties ?? [];
    const mergedReportingParties = eventPanelForm?.mergedReportingParties ?? [];
    const allReportingParties = [...reportingParties, ...mergedReportingParties];

    const involvedPersons = eventPanelForm?.involvedPersons ?? [];
    const mergedInvolvedPersons = eventPanelForm?.mergedInvolvedPersons ?? [];
    const allInvolvedPersons = [...involvedPersons, ...mergedInvolvedPersons];

    const phoneNumbers = uniq(
        compact([
            ...allReportingParties.map((rp) => rp.phoneNumber),
            ...allInvolvedPersons.map((ip) => ip.phoneNumber),
        ])
    );

    const vehicles = eventPanelForm?.vehicles ?? [];
    const mergedVehicles = eventPanelForm?.mergedVehicles || [];
    const allVehicles = [...vehicles, ...mergedVehicles];

    return (
        <RelatedDataStoreProvider eventId={props.eventId}>
            <RelatedDataPollExistingEvent
                eventId={props.eventId}
                eventLastUpdatedDateUtc={eventMetadata?.lastUpdatedDateUtc}
            />
            <RelatedDataTabContentExistingEvent
                reportingParties={allReportingParties}
                phoneNumbers={phoneNumbers}
                vehicles={allVehicles}
                location={eventPanelForm?.location}
            />
        </RelatedDataStoreProvider>
    );
});
